"use client"; // Error boundaries must be Client Components

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    // global-error replaces the root layout when active, so it must render
    // its own <html> and <body>.
    <html lang="en">
      <body style={{ fontFamily: "system-ui, sans-serif", padding: "4rem 2rem", textAlign: "center" }}>
        <h2>Something went wrong</h2>
        <p>An unexpected error occurred. Please try again.</p>
        <button
          onClick={() => unstable_retry()}
          style={{
            marginTop: "1rem",
            padding: "0.5rem 1.5rem",
            cursor: "pointer",
            borderRadius: "0.375rem",
            border: "1px solid #ccc",
            background: "#fff",
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
